'use client';

import { useUnleashContext } from '@unleash/nextjs/client';
import { useEffect } from 'react';
import { getFeatureFlagContext } from '@/libs/feature-flags/context';
import { useUserMeQuery } from '@/queries/user/user.queries';

/** Keeps browser-side flag targeting aligned with the authenticated identity. */
export function FeatureFlagsIdentitySync() {
  const { data: user } = useUserMeQuery();
  const updateContext = useUnleashContext();

  useEffect(() => {
    const context = user?.id && user.market
      ? getFeatureFlagContext({ id: user.id, market: user.market })
      : {};

    void updateContext(context).catch(() => {
      // Consumers keep their disabled fallback when context refresh fails.
    });
  }, [updateContext, user?.id, user?.market]);

  return null;
}
